import React, { useEffect, useRef, useContext } from "react";
import { WrapPageContext } from "./ContextWrapper";

const HeaderIdLoader = ({ children, currentPath, currentHash }) => {
	const wrapperRef = useRef();
	const { setHeadingNodes, tocHeadersQuery, forceUpdateTocVal } = useContext(
		WrapPageContext
	);

	useEffect(() => {
		const headers = Array.from(
			wrapperRef.current.querySelectorAll(tocHeadersQuery)
		).filter(
			h =>
				!h.classList.contains("sr-only") &&
				!h.classList.contains("esri-popup__header-title") &&
				!h.classList.contains("esri-popup__feature-menu-header")
		);

		setHeadingNodes(headers);
	}, [currentHash, currentPath, tocHeadersQuery, forceUpdateTocVal]);

	return <div ref={wrapperRef}>{children}</div>;
};

export default HeaderIdLoader;
